import React, {useEffect, useState} from "react";
import Form from 'components/Form';
import {withRouter} from "react-router";
import ValidationShema from "constants/ValidationShema";
import DemandAdditionalInfoService from "services/DemandAdditionalInfoService";
import Loading from "components/Loading";
import FormTranslationContext from "context/FormTranslationContext";
import NoticeYesNoInput from "components/complex/nationalNotice/components/inputs/NoticeYesNoInput";
import {connect} from "react-redux";
import {setFormDraftLoaded, setOpenForm, setOpenImporter} from "redux/actions";
import NoticeIntegerInput from "components/complex/nationalNotice/components/inputs/NoticeIntegerInput";
import {Accordion, AccordionDetails, AccordionSummary, Collapse, makeStyles} from "@material-ui/core";
import NoticeGlossaryInput from "components/complex/nationalNotice/components/inputs/NoticeGlossaryInput";
import NoticeNumericInput from "components/complex/nationalNotice/components/inputs/NoticeNumericInput";
import SaveFormikValues from "components/SaveFormikValues";
import useStepperStateCloseValidator from "hooks/useStepperStateCloseValidator";
import Typography from "components/Typography";
import GridBlock from "components/GridBlock";
import BoldTypography from "components/BoldTypography";
import Confirm from "components/popup/confirm/Confirm";
import AutoSaveFormValues from "components/AutoSaveFormValues";
import saveFormDraft from "libs/saveFormDraft";

const useStyle = makeStyles(theme => ({
    italic: {
        fontStyle: 'italic'
    },
    exceptionChip: {
        "& .MuiChip-label": {
            maxWidth: "100%"
        }
    },
}))

function getKey(id) {
    const split = id.split(".").filter(x => !/^\d+$/.test(x));
    split.unshift("common.form.demandadditionalinfo");
    return split.join(".");
}

function PreparingAdditionalInfo(
    {
        match,
        sectionId,
        formId,
        demandValidation,
        stepperState,
        demandHeader,
        setFormDraftLoaded
    }) {
    const classes = useStyle();
    const section = demandValidation.find(x => x.section === sectionId);
    const editable = section ? section.editable : false;
    const id = match.params.id;
    const [initData, setInitData] = useState(null);
    const [dictionaries, setDictionaries] = useState(null);
    const [translations, setTranslations] = useState(null);
    const [draftConfirm, setDraftConfirm] = useState(false);
    const [working, setWorking] = useState(false);
    const autoSaveFormDraftActive = demandHeader?.applicationClientSettings.autoSaveFormDraft.active;
    useStepperStateCloseValidator(formId, undefined,
        autoSaveFormDraftActive ? () => DemandAdditionalInfoService.deleteDraft(id) : undefined,
        autoSaveFormDraftActive ? () => saveFormDraft(id, DemandAdditionalInfoService.saveDraft, formId) : undefined);

    const formTr = (id) => {
        const key = getKey(id);
        return translations.labels[key] || key;
    }
    const formTip = (id) => {
        const key = getKey(id);
        return translations.tips[key];
    }

    const getDict = (id) => {
        return dictionaries[id].items;
    }


    useEffect(() => {
        DemandAdditionalInfoService.getDemandAdditionalInfoWrapper(id).then(values => {
            setInitData(values.form);
            setDictionaries(values.dictionaries);
            setTranslations(values.translations);
            if (autoSaveFormDraftActive)
                DemandAdditionalInfoService.checkForDraft(id).then(res => setDraftConfirm(res.result));
        })
    }, [id, autoSaveFormDraftActive])

    const handleSubmit = (values, formikProps) => {
        DemandAdditionalInfoService.saveDemandAdditionalInfo(id, values, sectionId)

    }

    const loadAdditionalInfoDraft = () => {
        setDraftConfirm(false);
        setWorking(true);
        DemandAdditionalInfoService.loadDraft(id).then(res => {
            setInitData(res.result);
            setFormDraftLoaded(formId, res.success);
        });
        setWorking(false);
    }

    if (!initData || !dictionaries || !translations || working) return (<Loading/>)

    return (
        <>
            <Form
                initialValues={initData}
                validationSchema={ValidationShema.any()}
                onSubmit={handleSubmit}
                id={formId}
            >{(formikProps) => (
                <FormTranslationContext.Provider value={{
                    formTr, formTip, getDict
                }}>
                    <SaveFormikValues
                        formikProps={formikProps}
                        id={formId}
                        save={formId === stepperState}
                    />
                    {autoSaveFormDraftActive &&
                    <AutoSaveFormValues
                        formikProps={formikProps}
                        id={id}
                        formId={formId}
                        saveFunc={(formValues) => {
                            DemandAdditionalInfoService.saveDraft(id, formValues)
                        }}
                    />
                    }
                    <Accordion defaultExpanded expanded>
                        <AccordionSummary>
                            <div>
                                <BoldTypography>{formTr("table_iv")}</BoldTypography>
                                <Typography className={classes.italic}>{formTr("table_iv_desc")}</Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridBlock column>
                                <NoticeIntegerInput
                                    id="numberConflictOfInterest"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeIntegerInput
                                    id="detectedAgreements"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeIntegerInput
                                    id="rejectedContractorOffer"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                            </GridBlock>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion defaultExpanded expanded>
                        <AccordionSummary>
                            <div>
                                <BoldTypography>{formTr("table_v")}</BoldTypography>
                                <Typography className={classes.italic}>{formTr("table_v_desc")}</Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridBlock column>
                                <NoticeYesNoInput
                                    id="communityReservedTender"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                            </GridBlock>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion defaultExpanded expanded>
                        <AccordionSummary>
                            <div>
                                <BoldTypography>{formTr("table_vi")}</BoldTypography>
                                <Typography className={classes.italic}>{formTr("table_vi_desc")}</Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridBlock column>
                                <NoticeYesNoInput
                                    id="socialReservedTender"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="definedSocialAspects"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="definedAccessibility"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="definedEmploymentRelationship"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="definedSocialAspectsRequirements"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="definedLabelSocialAspects"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeGlossaryInput
                                    id="contractorType"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                    items={getDict("SL.MMiA.062")}
                                />
                            </GridBlock>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion defaultExpanded expanded>
                        <AccordionSummary>
                            <div>
                                <BoldTypography>{formTr("table_vii")}</BoldTypography>
                                <Typography className={classes.italic}>{formTr("table_vii_desc")}</Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridBlock column>
                                <NoticeYesNoInput
                                    id="envRequirements"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="envSystemStandards"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="envAspectsInEvaluationCriteria"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="lifeCycleCostingApplied"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="envAspectsRequirements"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="definedLabelEnvAspects"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="innAspectsInEvaluationCriteria"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                                <NoticeYesNoInput
                                    id="innAspectsRequirements"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                />
                            </GridBlock>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion defaultExpanded expanded>
                        <AccordionSummary>
                            <div>
                                <BoldTypography>{formTr("table_viii")}</BoldTypography>
                                <Typography className={classes.italic}>{formTr("table_viii_desc")}</Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridBlock column>
                                <NoticeGlossaryInput
                                    className={classes.exceptionChip}
                                    id="exclusionReason"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                    items={getDict("SL.MMiA.063").map((item, index) => ({
                                        label: index + " - " + item.label,
                                        value: item.value
                                    })).filter(x => x.value !== "0")}
                                />
                            </GridBlock>
                        </AccordionDetails>
                    </Accordion>

                    <Accordion defaultExpanded expanded>
                        <AccordionSummary>
                            <div>
                                <BoldTypography>{formTr("table_ix")}</BoldTypography>
                                <Typography className={classes.italic}>{formTr("table_ix_desc")}</Typography>
                            </div>
                        </AccordionSummary>
                        <AccordionDetails>
                            <GridBlock column>
                                <NoticeGlossaryInput
                                    id="notIncludeReason"
                                    formikProps={formikProps}
                                    disabled={!editable}
                                    items={getDict("SL.MMiA.064")}
                                    prefixLabelsWithKeys
                                />
                            </GridBlock>
                        </AccordionDetails>
                    </Accordion>

                    <Collapse in={demandHeader.passiveOfferForm}>
                        <Accordion defaultExpanded expanded>
                            <AccordionSummary>
                                <div>
                                    <BoldTypography>{formTr("contract")}</BoldTypography>
                                    <Typography className={classes.italic}>{formTr("contract_desc")}</Typography>
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <GridBlock column>
                                    <NoticeNumericInput
                                        id="contractValue"
                                        formikProps={formikProps}
                                        disabled={!editable}
                                    />
                                </GridBlock>
                            </AccordionDetails>
                        </Accordion>
                    </Collapse>

                </FormTranslationContext.Provider>
            )}

            </Form>
            <Confirm
                open={draftConfirm}
                onConfirm={loadAdditionalInfoDraft}
                onCancel={() => setDraftConfirm(false)}
                confirmText="form_draft_load_confirm_text"
                confirmTitle="form_draft_load_confirm_title"
            />
        </>
    )
}

PreparingAdditionalInfo.propTypes = {}

export default connect((state) => ({
    demandValidation: state.resources.demandValidation,
    stepperState: state.stepper.state,
    demandHeader: state.resources.demandHeader
}), {
    setOpenForm, setOpenImporter, setFormDraftLoaded
})(withRouter(PreparingAdditionalInfo));
